"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _GALLERY_CONSTS$place = _constants.GALLERY_CONSTS.placements,
    SHOW_ABOVE = _GALLERY_CONSTS$place.SHOW_ABOVE,
    SHOW_BELOW = _GALLERY_CONSTS$place.SHOW_BELOW;
var _default = {
  title: 'Text Space From Image',
  isRelevant: function isRelevant(styleParams) {
    return (styleParams.allowTitle || styleParams.allowDescription) && styleParams.imageInfoType === _constants.GALLERY_CONSTS.infoType.SEPARATED_BACKGROUND && [SHOW_ABOVE, SHOW_BELOW].indexOf(styleParams.titlePlacement) > -1;
  },
  type: _constants.INPUT_TYPES.NUMBER,
  "default": 10,
  description: "Set the space between the item and the texts in the gallery. Note that this option is relevant\n  to galleries with texts separated from the image (texts below image or above image).\n  "
};
exports["default"] = _default;